module.exports = __webpack_public_path__ + "assets/img/47c7-bg.svg";